import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SignUpForm from '../SignUpForm';
import Stack from '../../../components/stack/Stack';
import { Button } from '@helsingborg-stad/municipio-react-ui';
export const GeneralError = (props) => (_jsx(SignUpForm, Object.assign({ volunteer: Object.assign({
        firstName: '-',
        lastName: '',
        id: '',
        email: '',
        phone: '',
        status: '',
    }), onSubmit: () => { } }, { children: _jsxs(Stack, Object.assign({ spacing: 3 }, { children: [_jsx(Button, Object.assign({ className: 'c-button__full-width', disabled: true, color: 'secondary', onClick: props.onClickClose }, { children: props.buttonLabel })), _jsx("div", Object.assign({ className: 'c-notice c-notice--danger' }, { children: _jsx("span", Object.assign({ className: "c-notice__message" }, { children: props.noticeText })) }))] })) })));
